const updateDomainGym = (state, { payload: { gym } }) => {
	state.gym = gym;
};

export default updateDomainGym;
